<template>
  <div>
    <div class="row animated fadeIn">
      <div class="col-md-8 offset-md-2">
        <div class="card ">
          <div class="card-header">
            <router-link :to="'../' + workflowId">
              <button type="button" class="btn btn-sm btn-secondary" style="margin-right:12px">
                <i class="fa fa-arrow-left"></i>
              </button>
            </router-link>
            <strong>Preview do workflow</strong>
            <div class="pull-right">
              <button v-show="showDiagram" id="downloadPreview" type="button" class="btn btn-sm btn-secondary" @click.prevent="download">
              Download
            </button>
            </div>
          </div>
          <div class="card-block">
            <div id="bpmnDiagram" v-show="showDiagram" style="height:450px;margin-top:15px" />

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import BpmnViewer from 'bpmn-js/lib/NavigatedViewer'
import axios from 'axios'

const viewer = new BpmnViewer({
  width: '100%',
  height: '100%'
})

export default {
  name: 'user',
  components: {

  },
  data() {
    return {
      workflowId: '',
      versionId: '',
      showDiagram: false,
      previewContent: ''
    }
  },
  mounted: function() {
    // this.showDiagram = false
    viewer.attachTo('#bpmnDiagram')
    document.querySelector('.bjs-powered-by>img').style.width = '10px'
    this.loadPreview()
  },
  created() {
    this.workflowId = this.$route.params.id
    this.versionId = this.$route.params.versionId
  },
  methods: {
    loadPreview() {
      axios.get(`${process.env.BEAST_MANAGER_API_URL}workflows/${this.workflowId}/versions/${this.versionId}/content`).then(response => {
        this.previewContent = response.data.content
        viewer.importXML(response.data.content, function(err) {
          if (err) {
            console.log('error rendering', err)
          } else {
            console.log('rendered')
          }
        })
        this.showDiagram = true
      }).catch(err => {
        console.error(err)
        this.showError('Ops. Ocorreu um erro ao carregar o bpmn.')
      })
    },
    download() {
      var filename = this.versionId + '_' + new Date().toISOString() + '.bpmn'
      var text = this.previewContent
      var pom = document.createElement('a')
      pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
      pom.setAttribute('download', filename)

      if (document.createEvent) {
        var event = document.createEvent('MouseEvents')
        event.initEvent('click', true, true)
        pom.dispatchEvent(event)
      } else {
        pom.click()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// VersionsPreview.vue?652c213b